var normalizeSlashes = function normalizeSlashes(path) {
  if (!path) return null;
  var newPath = path;
  if (!path.endsWith('/')) newPath = "".concat(newPath, "/");
  if (!path.startsWith('/')) newPath = "/".concat(newPath);
  return newPath;
};
export default normalizeSlashes;